import { gridStateDefault, GRID_STATE } from "../consts";

const myState = { ...gridStateDefault }

export const setGridState =  newState => {
    
    return{ 
        type: GRID_STATE, 
        payload : {...myState, ...newState} 
    }

} 


export default function gridStateReducer(state = myState, { type, payload }) {
   
    const actions = {
        [GRID_STATE] : () => ({...payload })
    }

    return actions[type]?.call() || state;
}